import {getData, postData} from './redux_data';
import {
    GET_PROMOCION,
    MODIFY_PROMOCION,
    ADD_PROMOCION,
    DELETE_PROMOCION,
    UPDATE_PROMOCION,
} from '../constants/action_types';

export function getPromocionList(centroId) {
    return getData('DCPromocions?centro_id='+centroId, GET_PROMOCION, centroId);
}

export function modifyPromocion(promocion) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_PROMOCION, payload: promocion });
    }
}

export function addPromocion(promocion) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_PROMOCION, payload: promocion });
    }
}

export function removePromocion(promocion) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_PROMOCION, payload: promocion });
    }
}

export function updatePromocionListDB (promocionList, centro_id) {
    return postData('DCPromocions/lista?centro_id=' + centro_id, UPDATE_PROMOCION, promocionList, 'Promociones del centro actualizadas', undefined);
}

